export var ExpiryStatus = {
  Invalid: 1,
  InvalidIfStale: 2,
  Valid: 3
}; // looser version to allow for cross-package version compatibility